import { css } from '@emotion/react';
import { token } from '@atlaskit/tokens';

import { VIEWING_WIDTH } from '@/styles/constants';
import {
  SPACE_COMFORTABLE,
  SPACE_COMPACT,
  SPACE_COZY,
  SPACE_MINIMUM,
  SPACE_RELAXED,
} from '@/styles';

export const root = css`
  width: ${VIEWING_WIDTH}px;
  margin: 0 auto;
`;

export const formFieldBlockStyles = css`
  display: flex;
  flex-direction: column;
  background-color: ${token('color.background.input.hovered')};
  // border: 2px solid ${token('color.border.input')};
  padding: ${SPACE_COZY}px;
  border-radius: 4px;
  margin-top: ${SPACE_COZY}px;
  & > label {
    font-weight: 500;
    background: ${token('color.background.neutral')};
    padding: 8px;
    border-radius: 4px;
    display: flex;
  }
`;

export const formField = css({
  '& label': {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    marginBottom: '0.5rem',
    fontWeight: 400,
    fontSize: '0.875rem',
  },

  '& [type="checkbox"]': {
    marginRight: '0.25rem',
  },
});

export const textAreaField = css({
  '& textarea': {
    minHeight: '80px',
  },
});

export const selectField = css({
  marginTop: SPACE_COMPACT,
  '& > div:first-of-type': {
    marginBottom: '4px',
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: 1.5,
  },
});

export const checkboxField = css({
  marginLeft: -4,
  '& label': {
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: 1.5,
  },
});

export const dateRangeContainer = css`
  & > div {
    width: 100%;
  }
  gap: ${SPACE_COMPACT}px;
  display: flex;
`;

export const formActions = css({
  display: 'flex',
  gap: '1rem',
  marginTop: '2rem',
});

export const loadingContainer = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '3rem 2rem',
  gap: '1rem',

  '& p': {
    fontSize: '1rem',
    fontWeight: 500,
  },
});

export const resultsContainer = css({
  marginTop: '2rem',
  padding: '2rem',
  border: `1px solid ${token('color.border')}`,
  borderRadius: '4px',
  backgroundColor: token('color.background.neutral'),
});

export const successResults = css({
  '& h3': {
    marginBottom: '1rem',
  },

  '& pre': {
    backgroundColor: token('color.background.input'),
    padding: '1rem',
    borderRadius: '4px',
    overflow: 'auto',
    fontSize: '0.85rem',
  },
});

export const errorResults = css({
  '& h3': {
    marginBottom: '0.5rem',
    color: token('color.text.danger'),
    fontSize: '1.1rem',
    fontWeight: 600,
  },

  '& p': {
    color: token('color.text.danger'),
    lineHeight: '1.5',
    marginBottom: '0.5rem',
  },
});

export const sfxIconStyles = css`
  div {
    height: 20px;
    width: 20px;
  }
`;

export const alertTypeGroup = css({
  border: `1px solid ${token('color.border')}`,
  borderRadius: SPACE_MINIMUM,
  overflow: 'hidden',
  backgroundColor: token('color.background.neutral'),
  marginBottom: SPACE_COMFORTABLE,
});

export const alertTypeHeader = css({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: SPACE_COZY,
  backgroundColor: token('color.background.neutral.subtle'),
  borderBottom: `1px solid ${token('color.border')}`,
});

export const alertTypeTitle = css({
  margin: 0,
  fontWeight: 600,
});

export const alertsGrid = css({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
  gap: SPACE_COZY,
  padding: SPACE_COZY,
});

export const alertCard = css({
  border: `1px solid ${token('color.border')}`,
  borderRadius: SPACE_MINIMUM,
  padding: SPACE_COZY,
  backgroundColor: token('color.background.input'),
  transition: 'box-shadow 0.15s ease-in-out',

  '&:hover': {
    boxShadow: token('elevation.shadow.raised'),
  },
});

export const alertTime = css({
  fontSize: 14,
  fontWeight: 600,
});

export const alertTimeOnly = css({
  display: 'flex',
  alignItems: 'center',
  gap: SPACE_COMPACT,
  justifyContent: 'flex-start',
});

export const noAlertsContainer = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: SPACE_RELAXED,
  textAlign: 'center',
  borderRadius: SPACE_MINIMUM,
  backgroundColor: token('color.background.neutral.subtle'),
});

export const noAlertsIcon = css({
  fontSize: 28,
  marginBottom: SPACE_COZY,
});

export const noAlertsSubtext = css({
  color: token('color.text.subtlest'),
  fontSize: 14,
  margin: `${SPACE_COMPACT}px 0 0 0`,
  lineHeight: 1.5,
});

export const alertDescriptionStyles = css({
  marginBottom: '1.5rem',
});

export const labelWithSubtext = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.25rem',
  alignItems: 'flex-start',
});
